import { combineReducers } from 'redux';

import loadSiteFooterLinksError from './loadSiteFooterLinksError';

import createSiteFooterLinkCategoryError from './createSiteFooterLinkCategoryError';
import setSiteFooterLinkCategoryTranslationError from './setSiteFooterLinkCategoryTranslationError';
import deleteSiteFooterLinkCategoryTranslationError from './deleteSiteFooterLinkCategoryTranslationError';
import deleteSiteFooterLinkCategoryError from './deleteSiteFooterLinkCategoryError';
import editSiteFooterLinkCategoryError from './editSiteFooterLinkCategoryError';

import createSiteFooterLinkError from './createSiteFooterLinkError';
import editSiteFooterLinkError from './editSiteFooterLinkError';
import deleteSiteFooterLinkError from './deleteSiteFooterLinkError';

import createSiteFooterLinkTranslationError from './createSiteFooterLinkTranslationError';
import deleteSiteFooterLinkTranslationError from './deleteSiteFooterLinkTranslationError';
import setSiteFooterLinkTranslationAvailabilityError from './setSiteFooterLinkTranslationAvailabilityError';
import editSiteFooterLinkTranslationError from './editSiteFooterLinkTranslationError';

export default combineReducers({
  loadSiteFooterLinksError,

  createSiteFooterLinkCategoryError,
  setSiteFooterLinkCategoryTranslationError,
  deleteSiteFooterLinkCategoryTranslationError,
  deleteSiteFooterLinkCategoryError,
  editSiteFooterLinkCategoryError,

  createSiteFooterLinkError,
  editSiteFooterLinkError,
  deleteSiteFooterLinkError,

  createSiteFooterLinkTranslationError,
  deleteSiteFooterLinkTranslationError,
  setSiteFooterLinkTranslationAvailabilityError,
  editSiteFooterLinkTranslationError,
});
